
import './ConversationSection.css';
import tellecomImg from '../../assets/tellecom.png';

const ConversationSection = () => {
    return (
        <section className="conversation-section">
            <div className="conversation-container">

                {/* LEFT CONTENT */}
                <div className="conversation-content">

                    <span className="conversation-badge">
                        Need More Information
                    </span>

                    <h2 className="conversation-title">
                        Start Your <br /> Conversation
                    </h2>

                    <p className="conversation-text">
                        Your real estate journey deserves the right guidance. Schedule a call today and discover
                        how Jeevan Realty can simplify buying, investing, and building your future with confidence.
                    </p>

                    <div className="conversation-cta">
                        <button className="cta-button">
                            Schedule a Call Now!
                            <span className="cta-arrow">→</span>
                        </button>
                    </div>

                </div>

                {/* RIGHT IMAGE */}
                <div className="conversation-image">
                    <img
                        src={tellecomImg}
                        alt="Schedule a call"
                        className="conversation-img"
                    />
                </div>

            </div>
        </section>
    );
};

export default ConversationSection;
